import { ResolverRegistry } from '@packages/form-engine';
import type { ConditionContext } from '@packages/form-engine';
import { validateJsonObjectString } from '@packages/shared/utils';
import {
  isHybridCliffsInvalid,
  isIntervalAtLeastTerm,
  isIntervalNotDivisibleByTerm,
} from '../helpers';

ResolverRegistry.registerValidation(
  'vestingTemplateSpecificVestingJson',
  (value: unknown, _formData: Record<string, unknown>, _ctx: ConditionContext) =>
    validateJsonObjectString(value),
);

ResolverRegistry.registerValidation(
  'vestingTemplateStepIntervalDivisible',
  (value: unknown, formData: Record<string, unknown>) => {
    if (isIntervalNotDivisibleByTerm(value, formData.lengthInMonths)) {
      return 'Vesting Frequency is invalid, enter a number that is divisible to Term Period';
    }
    return null;
  },
);

ResolverRegistry.registerValidation(
  'vestingTemplateIntervalMaxLessThanTerm',
  (value: unknown, formData: Record<string, unknown>) => {
    if (isIntervalAtLeastTerm(value, formData.lengthInMonths)) {
      return 'Please enter a valid Vesting Frequency less than the Term Period';
    }
    return null;
  },
);

ResolverRegistry.registerValidation(
  'vestingTemplateHybridCliffsMax',
  (value: unknown, formData: Record<string, unknown>) => {
    if (isHybridCliffsInvalid(value, formData.lengthInMonths)) {
      return 'Please enter a valid Cliffs less than the Term Period';
    }
    return null;
  },
);
